import { render, staticRenderFns } from "./APIDataPage.vue?vue&type=template&id=5dd20f8a&scoped=true&"
import script from "./APIDataPage.vue?vue&type=script&lang=js&"
export * from "./APIDataPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=5dd20f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd20f8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VLayout,VMain})
